import * as constants from './constants'

export const initialState = {
  selectedCultureCode: 'en-us',
  selectedStatus: 'all',
  availableLanguages: [],
  updatingLanguages: false,
  availableProducts: [],
  updatingProducts: false,
  selectedProducts: [],
  updatingTranslations: false,
  search: '',
  error: null,
  updateProductError: null,
  updatingProduct: false,
  addNewTranslation: null,
  addNewTranslationPending: false,
  addNewTranslationError: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // select language
    case constants.SET_SELECTED_LANGUAGE:
      return {
        ...state,
        selectedCultureCode: action.selectedCultureCode
      }
    // selected status
    case constants.SET_SELECTED_STATUS:
      return {
        ...state,
        selectedStatus: action.selectedStatus
      }
    // available languages
    case constants.GET_AVAILABLE_LANGUAGES:
      return {
        ...state,
        error: null,
        updatingLanguages: false
      }
    case constants.GET_AVAILABLE_LANGUAGES_PENDING:
      return {
        ...state,
        updatingLanguages: true
      }
    case constants.GET_AVAILABLE_LANGUAGES_FULFILLED:
      return {
        ...state,
        updatingLanguages: false,
        availableLanguages: action.body
      }
    case constants.GET_AVAILABLE_LANGUAGES_ERROR:
      return {
        ...state,
        error: action.body,
        updatingLanguages: false
      }
    // add translation
    case constants.RESET_ADD_TRANSLATION:
      return {
        ...state,
        addNewTranslation: null,
        addNewTranslationPending: false,
        addNewTranslationError: null
      }
    case constants.ADD_TRANSLATION:
      return {
        ...state,
        addNewTranslationError: null,
        addNewTranslationPending: false
      }
    case constants.ADD_TRANSLATION_PENDING:
      return {
        ...state,
        addNewTranslationPending: true
      }
    case constants.ADD_TRANSLATION_FULFILLED:
      return {
        ...state,
        addNewTranslationPending: false,
        addNewTranslation: action.body
      }
    case constants.ADD_TRANSLATION_ERROR:
      return {
        ...state,
        addNewTranslationError: action.body,
        addNewTranslationPending: false
      }
    // selected products
    case constants.SET_SELECTED_PRODUCTS:
      return {
        ...state,
        selectedProducts: [...action.selectedProducts]
      }
    // available products
    case constants.GET_AVAILABLE_PRODUCTS:
      return {
        ...state,
        error: null,
        updatingProducts: false
      }
    case constants.GET_AVAILABLE_PRODUCTS_PENDING:
      return {
        ...state,
        updatingProducts: true
      }
    case constants.GET_AVAILABLE_PRODUCTS_FULFILLED:
      return {
        ...state,
        updatingProducts: false,
        availableProducts: action.body
      }
    case constants.GET_AVAILABLE_PRODUCTS_ERROR:
      return {
        ...state,
        error: action.body,
        updatingProducts: false
      }
    // translations
    case constants.GET_TRANSLATIONS_FOR_PRODUCT:
      return {
        ...state,
        error: null,
        updatingTranslations: false
      }
    case constants.GET_TRANSLATIONS_FOR_PRODUCT_PENDING:
      return {
        ...state,
        updatingTranslations: true
      }
    case constants.GET_TRANSLATIONS_FOR_PRODUCT_FULFILLED:
      return {
        ...state,
        updatingTranslations: false
      }
    case constants.GET_TRANSLATIONS_FOR_PRODUCT_ERROR:
      return {
        ...state,
        error: action.body,
        updatingTranslations: false
      }
    // set search
    case constants.SET_SEARCH:
      return {
        ...state,
        search: action.search
      }
    // update product
    case constants.UPDATE_PRODUCT:
      return {
        ...state,
        updateProductError: null,
        updatingProduct: false
      }
    case constants.UPDATE_PRODUCT_PENDING:
      return {
        ...state,
        updatingProduct: true
      }
    case constants.UPDATE_PRODUCT_FULFILLED:
      const availableProducts = state.availableProducts
      for (const i in availableProducts) {
        if (availableProducts[i].name === action.body.name) {
          availableProducts[i].display_name = action.body.display_name
          availableProducts[i].is_visible = action.body.is_visible
        }
      }
      return {
        ...state,
        updatingProduct: false,
        availableProducts: [...availableProducts]
      }
    case constants.UPDATE_PRODUCT_ERROR:
      return {
        ...state,
        updateProductError: action.body || 'Something went wrong updating product',
        updatingProduct: false
      }
  }
  return state
}

export default reducer
